export default function Logo({ className = "h-6 w-6 text-white" }) {
  return (
    <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true">
      <rect width="32" height="32" rx="5" fill="rgba(255,255,255,0.07)" />
      <rect x="9" y="6" width="4" height="20" fill="currentColor" />
      <rect x="13" y="6" width="11" height="4" fill="currentColor" />
      <rect x="13" y="14" width="8" height="4" fill="currentColor" />
      <rect x="13" y="22" width="5" height="4" fill="#10B981" />
    </svg>
  );
}
